/*------------------------------------------------
// File Name:PDM_MA_SchdTime.js
// File Description:PDM_MA_SchdTime store方法
// Author:zxl
// Create Time:2023/06/06 15:36:13
//------------------------------------------------*/

import {
  GetPDM_MA_SchdTimeList,
  GetPDM_MA_SchdTimeListByPage,
  GetPDM_MA_SchdTimeEntity,
  CreatePDM_MA_SchdTimeEntity,
  UpdatePDM_MA_SchdTimeEntity,
  DeletePDM_MA_SchdTimeEntity,
} from "@/api/pdm/ma/maSchdtime";

import msg from "@/config/notify";
import dlg from "@/config/dialog";
//import { toRaw } from "vue";

export const PdmMaSchdtime = {
  namespaced: true,
  state: {
    PdmMaSchdtimeList: [],
    PdmMaSchdtimeListLoading: false,
    PdmMaSchdtimeEntity: null,
    PdmMaSchdtimeShowDlg: false,
    ShangWuTimeList: [],
    XiaWuTimeList: [],
    PaiBanTimeShangWuList: [],
    PaiBanTimeXiagWuList: [],
  },
  mutations: {
    setPaiBanTimeShangWuList(state, dataList) {
      state.PaiBanTimeShangWuList = dataList;
    },
    setPaiBanTimeXiagWuList(state, dataList) {
      state.PaiBanTimeXiagWuList = dataList;
    },
    setShangWuTimeList(state, dataList) {
      state.ShangWuTimeList = dataList;
    },
    setXiaWuTimeList(state, dataList) {
      state.XiaWuTimeList = dataList;
    },
    setPdmMaSchdtimeList(state, dataList) {
      state.PdmMaSchdtimeList = [...dataList];
    },
    setPdmMaSchdtimeListLoading(state, visible) {
      state.PdmMaSchdtimeListLoading = visible;
    },
    setPdmMaSchdtimeShowDlg(state, visible) {
      state.PdmMaSchdtimeShowDlg = visible;
    },
    setPdmMaSchdtimeEntity(state, entity) {
      state.PdmMaSchdtimeEntity = entity;
    },
  },
  actions: {
    //创建体检预约排班表-时间对象
    actCreatePdmMaSchdtime({ commit }, parm) {
      return new Promise((resolve, reject) => {
        CreatePDM_MA_SchdTimeEntity(parm).then((res) => {
          if (res.Code == 0) {
            commit("setPdmMaSchdtimeEntity", res.Data);
            commit("setPdmMaSchdtimeListLoading", true);
            //msg.success(res.Message)
            resolve(res);
          } else {
            dlg.alert(res.Message);
            reject(res);
          }
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //加载体检预约排班表-时间对象
    actGetPdmMaSchdtimeEntity({ commit }, parm) {
      return new Promise((resolve) => {
        commit("setPdmMaSchdtimeListLoading", true);
        GetPDM_MA_SchdTimeEntity(parm)
          .then((res) => {
            if (res.Code == 0) {
              commit("setPdmMaSchdtimeEntity", res.Data);
              //msg.success(res.Message)
              resolve(res);
            } else {
              dlg.alert(res.Message);
              //msg.error(res.Message)
            }
          })
          .finally(() => {
            commit("setPdmMaSchdtimeListLoading", false);
          });
      }).catch((err) => {
        console.log(err);
      });
    },
    //加载体检预约排班表-时间列表
    actGetPdmMaSchdtimeList({ commit }, parm) {
      return new Promise((resolve) => {
        commit("setPdmMaSchdtimeListLoading", true);
        GetPDM_MA_SchdTimeList(parm)
          .then((res) => {
            if (res.Code == 0) {
              commit("setPdmMaSchdtimeList", res.Data);
              //msg.success(res.Message)
              resolve(res);
            } else {
              dlg.alert(res.Message);
              //msg.error(res.Message)
            }
          })
          .finally(() => {
            commit("setPdmMaSchdtimeListLoading", false);
          });
      }).catch((err) => {
        console.log(err);
      });
    },
    //分页加载体检预约排班表-时间列表
    actGetPdmMaSchdtimeListByPage({ commit }, parm) {
      return new Promise((resolve) => {
        commit("setPdmMaSchdtimeListLoading", true);
        GetPDM_MA_SchdTimeListByPage(parm)
          .then((res) => {
            if (res.Code == 0) {
              commit("setPdmMaSchdtimeList", res.Data);
              //msg.success(res.Message)
              resolve(res);
            } else {
              dlg.alert(res.Message);
              // msg.error(res.Message)
            }
          })
          .finally(() => {
            commit("setPdmMaSchdtimeListLoading", false);
          });
      }).catch((err) => {
        console.log(err);
      });
    },
    //保存体检预约排班表-时间信息
    actUpdatePdmMaSchdtime({ commit }, parm) {
      return new Promise((resolve) => {
        UpdatePDM_MA_SchdTimeEntity(parm).then((res) => {
          if (res.Code == 0) {
            commit("setPdmMaSchdtimeShowDlg", false);
            msg.success(res.Message);
            resolve(res);
          } else {
            dlg.alert(res.Message);
            resolve(res);
          }
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //编辑PDM_MA_SchdTime
    actEditPdmMaSchdtimeData({ commit }, entity) {
      return new Promise((resolve) => {
        let parm = {
          PdmMaSchdtimeID: entity.PdmMaSchdtimeID,
        };
        GetPDM_MA_SchdTimeEntity(parm).then((res) => {
          if (res.Code == 0) {
            // var info = {}
            // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
            // Object.assign(info,res.Data)
            // commit('getTableNameL3(TableName.Name)%>Entity', info)
            commit("setPdmMaSchdtimeEntity", res.Data);
            commit("setPdmMaSchdtimeShowDlg", true);
            msg.success(res.Message);
            resolve(res);
          } else {
            dlg.alert(res.Message);
            resolve(res);
          }
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //编辑PDM_MA_SchdTime ,传对象过来
    actEditPdmMaSchdtime({ commit }, entity) {
      return new Promise(() => {
        commit("setPdmMaSchdtimeEntity", entity);
        commit("setPdmMaSchdtimeShowDlg", true);
      }).catch((err) => {
        console.log(err);
      });
    },
    //删除PDM_MA_SchdTime
    actDeletePdmMaSchdtime({ commit }, e) {
      return new Promise((resolve) => {
        dlg.confirm("是否确定要删除当前体检预约排班表-时间？").onOk(() => {
          DeletePDM_MA_SchdTimeEntity(e).then((res) => {
            if (res.Code == 0) {
              commit("setPdmMaSchdtimeShowDlg", false);

              msg.success("删除体检预约排班表-时间成功。");
              resolve(res);
            } else {
              dlg.alert("删除体检预约排班表-时间失败，原因:" + res.Message);
              //msg.success("删除体检预约排班表-时间失败，原因:" + res.Message)
              resolve(res);
            }
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
